import type { ReturnPageHookProps } from "@b2bportal/core-flights";
import { useReturnPageRoute, useReturnPageContainer } from "@tenant/flights";

export const useReturnPage = ({ goToNextStep }: ReturnPageHookProps) => {
  useReturnPageRoute();
  return useReturnPageContainer({ goToNextStep });
};
